import { RouterEffects } from './router.effect';
import { MetaEffects } from './meta.effect';

export const appEffects = [RouterEffects, MetaEffects];

export * from './router.effect';
export * from './meta.effect';
